let abortAllHandler: (() => void) | undefined;

export function registerMediaFetchAbortHandler(handler: () => void) {
  abortAllHandler = handler;
}

export function abortAllMediaFetches() {
  abortAllHandler?.();
}
